import { ForgotPassword } from '~/pages/password-forgot'

export default ForgotPassword
